<template>
  <div>
    <div class="bg">
      <div class="item" v-for="(item, index) in list" :key="index" @click="tapFn(item.id)">
        <div class="item-icon">
          <img :src="$env.imgUrl + item.img" alt="">
        </div>
        <div class="item-cn">{{ item.cn }}</div>
        <div class="item-en">{{ item.en }}</div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
      list: [
        {
          id: 1,
          img: 'sidebar-2.png',
          cn: '注册信息',
          en: 'Information'
        },
        {
          id: 2,
          img: 'sidebar-1.png',
          cn: '组队报名',
          en: 'Register'
        }
        // {
        //   id: 3,
        //   img: 'sidebar-3.png',
        //   cn: '下载指南',
        //   en: 'Download'
        // }
      ]
    }
  },
  methods: {
    scrollToTop () {
      this.$emit('toTop')
    },
    tapFn (id) {
      if (id === 1) {
        this.$router.push('/chnEngRegist')
      } else if (id === 2) {
        const userInfoData = localStorage.getItem('saveUserInfo')
        if (userInfoData) {
          this.$router.push('/club/home')
        } else {
          this.$router.push('/loginview')
        }
      }
    }
  }
}
</script>
<style lang="less" scoped>
.bg{
  position: fixed;
  right: 30px;
  bottom: 100px;
  background-color: rgba(255, 255, 255, .6);
  border-radius: 56px;
  width: 56px;
  padding-bottom: 10px;
  .item{
    text-align: center;
    .item-icon{
      width: 40px;
      height: 40px;
      background-color: #fff;
      border-radius: 40px;
      box-shadow: 0 2px 14px rgba(0, 0, 0, 0.3);
      margin: 8px auto;
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;
      img{
        width: 22px;
        height: 22px;
        object-fit: cover;
      }
    }
    .item-cn{
      color: #C9273A;
      font-family: systh;
      font-size: 12px;
    }
    .item-en{
      color: #C9273A;
      font-family: systm;
      font-size: 8px;
    }
  }
}
</style>
